import { postRequest } from '.';

interface DispositionData {
  transaction_id: string | number;
  problem_reason_msg?: string;
  user_id: string;
  station_id: string;
}

interface FinishReceiptData {
  transaction_id: string | number;
  user_id: string;
  station_id: string;
  override_ind?: 'y' | 'n';
}

export const submitDisposition = async (dispositionData: DispositionData) => {
  const payload = {
    transaction_id: dispositionData.transaction_id,
    problem_reason_msg: dispositionData.problem_reason_msg || 'Item moved to disposition stage',
    user_id: dispositionData.user_id,
    station_id: dispositionData.station_id,
  };

  return postRequest('receipt-graded-problem', payload);
};

export const finishReceipt = async (finishData: FinishReceiptData) => {
  const payload = {
    transaction_id: finishData.transaction_id,
    user_id: finishData.user_id,
    station_id: finishData.station_id,
    override_ind: finishData.override_ind || 'n',
  };

  return postRequest('receipt-graded-finish', payload);
};
